import { register } from '../../../JavaScript/Utils'

export const AccordionContainer = (el: HTMLElement) => {
  const openFirst = el.dataset.openFirst ? true : false
  const slides: NodeListOf<HTMLElement> = el.querySelectorAll('.slide-toggler')
  let activeSlide: HTMLElement = null

  const getContentElement = (container: HTMLElement):HTMLElement => container.closest('.slide-accordion-header').nextElementSibling as HTMLElement

  const deactivateSlide = (slide: HTMLElement) => {
    const contentElement = getContentElement(slide)
    contentElement.style.height = '0px'
    contentElement.setAttribute('aria-hidden', 'true');
    contentElement.setAttribute('inert', '');

    slide.closest('.slide-accordion-container').classList.remove('is--active')
    slide.setAttribute('aria-expanded', 'false');
  }

  const activateSlide = (slide: HTMLElement) => {
    slide.closest('.slide-accordion-container').classList.add('is--active')
    const contentElement = getContentElement(slide)
    contentElement.style.height = `${contentElement.scrollHeight}px`
    contentElement.setAttribute('aria-hidden', 'false');
    contentElement.removeAttribute("inert");
    slide.setAttribute('aria-expanded', 'true');
    activeSlide = slide
  }

  const changeSlide = (targetSlide: HTMLElement) => {
    if (activeSlide) {
      deactivateSlide(activeSlide)
    }

    if (activeSlide === targetSlide) {
      activeSlide = null
      return
    }

    activateSlide(targetSlide)
  }

  slides.forEach(slide => slide.addEventListener('click', e => changeSlide(e.currentTarget as HTMLElement)))

  if (openFirst) {
    changeSlide(slides[0])
  }
}

register('AccordionContainer', AccordionContainer)
